export default __webpack_public_path__ + "static/media/fontLato700_latin.8f28e0e1.woff2";